module.exports = "\r\n<mms-banner></mms-banner>\r\n\r\n<div class=\"page-error\">\r\n\r\n\t<h1>OOPS…</h1>\r\n\t<h2>There is nothing at this address!</h2>\r\n\r\n\t<p>You may have clicked on an expired link or typed an incomplete address. Check for newer emails. Be sure to click the button in the email or copy the full link and paste it in your browser’s address bar.</p>\r\n\r\n\t<p>Please contact your healthcare provider if you need further assistance.\r\n\r\n</div>\r\n\r\n<mms-footer></mms-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/404.html
// module id = 674
// module chunks = 0